export const environment = {
    production: false,
    principal_link: "http://theraskin.com.br/backend-api/",
    baseUrl: "http://theraskin.com.br/backend-api/wp-json/",
};


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts